<template>
  <div>VUE</div>
</template>

<script>
export default {
  name: 'VideoContain'
}
</script>

<style scoped lang="scss">

</style>
